export const state = () => {
  return {
    list: [],
  }
}

export const actions = {
  async getList({ commit }) {
    const { errResponse, data: responseData } = this.$adminRepositories.applications.listTransferRequest()
    
    if (!errResponse && responseData.success) {
      return commit('setList', responseData.data);
    }
  },
}

export const mutations = {
  setList: (state, data) => (state.list = data),
}
